import type { ElementPosition } from '../layout/element/types';
import type { ParsedElementType, ParsedStructuredElementType } from '../layout/types';

/**
 * Generic position type used for filtering elements by position attribute
 * Includes both the specific ElementPosition values and the generic position identifiers
 */
type GenericPosition = 'top' | 'bottom' | 'left' | 'right' | ElementPosition;

/**
 * Get elements for a specific position, filtering out string elements
 */
export const getElementsForPosition = (
	elements: ParsedElementType[],
	position: GenericPosition,
	defaultIndex: number,
): ParsedStructuredElementType[] => {
	const result: ParsedStructuredElementType[] = [];

	for (let i = 0; i < elements.length; i++) {
		const element = elements[i];
		if (typeof element === 'string') {
			continue;
		}
		if (element.attributes?.pos === position || (i === defaultIndex && !element.attributes?.pos)) {
			result.push(element);
		}
	}

	return result;
};
